export default "__VITE_ASSET__DKKaevGW__"